import React, { useState, useEffect, useRef } from "react";

const TimePicker24 = ({ value, onChange, placeholder = "--:--" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selH = value ? parseInt(value.split(":")[0], 10) : null;
  const selM = value ? parseInt(value.split(":")[1], 10) : null;
  const minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (h, m) => {
    onChange(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block", width: "100%" }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          width: "100%", height: "36px", display: "flex", alignItems: "center",
          gap: "8px", padding: "0 10px", boxSizing: "border-box",
          border: "1px solid #d1d5db", borderRadius: "6px",
          background: "#fff", cursor: "pointer", fontSize: "14px",
          fontFamily: "monospace", color: value ? "#111" : "#9ca3af",
        }}
      >
        <i className="fas fa-clock" style={{ fontSize: "13px", color: "#9ca3af" }} />
        {value || placeholder}
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 200,
          background: "#fff", border: "1px solid #e5e7eb", borderRadius: "10px",
          padding: "8px", display: "flex", gap: "4px", width: "160px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
        }}>
          {/* Hours */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: "10px", fontWeight: 500, color: "#9ca3af", textAlign: "center", textTransform: "uppercase", letterSpacing: "0.05em", paddingBottom: "4px", borderBottom: "1px solid #f3f4f6", marginBottom: "4px" }}>HH</div>
            <div style={{ height: "168px", overflowY: "auto", scrollbarWidth: "none" }}>
              {Array.from({ length: 24 }, (_, h) => (
                <div
                  key={h}
                  onClick={() => selM !== null ? select(h, selM) : (() => { /* just highlight */ })()}
                  onMouseDown={(e) => e.preventDefault()}
                  style={{
                    height: "28px", display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "13px", fontFamily: "monospace", borderRadius: "6px", cursor: "pointer",
                    background: selH === h ? "rgba(59,130,246,0.1)" : "transparent",
                    color: selH === h ? "#2563eb" : "#374151", fontWeight: selH === h ? 500 : 400,
                  }}
                  onClick={() => selM !== null ? select(h, selM) : onChange(`${String(h).padStart(2,"0")}:${String(selM ?? 0).padStart(2,"0")}`)}
                >
                  {String(h).padStart(2, "0")}
                </div>
              ))}
            </div>
          </div>

          <div style={{ width: "1px", background: "#f3f4f6", alignSelf: "stretch" }} />

          {/* Minutes */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: "10px", fontWeight: 500, color: "#9ca3af", textAlign: "center", textTransform: "uppercase", letterSpacing: "0.05em", paddingBottom: "4px", borderBottom: "1px solid #f3f4f6", marginBottom: "4px" }}>MM</div>
            <div style={{ height: "168px", overflowY: "auto", scrollbarWidth: "none" }}>
              {minutes.map((m) => (
                <div
                  key={m}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => selH !== null ? select(selH, m) : onChange(`${String(selH ?? 0).padStart(2,"0")}:${String(m).padStart(2,"0")}`)}
                  style={{
                    height: "28px", display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "13px", fontFamily: "monospace", borderRadius: "6px", cursor: "pointer",
                    background: selM === m ? "rgba(59,130,246,0.1)" : "transparent",
                    color: selM === m ? "#2563eb" : "#374151", fontWeight: selM === m ? 500 : 400,
                  }}
                >
                  {String(m).padStart(2, "0")}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimePicker24;